import React from 'react';
import './Navbar.css';

function Navbar() {
  return (
    <nav className='navbar'>
      <div className="navbar-container minimal-navbar">
        <a href="/" className="navbar-logo">
          <img
            src={process.env.PUBLIC_URL + '/symphonic_waves_wordmark_001_black.svg'}
            alt="Symphonic Logo"
            className="navbar-logo-image"
          />
        </a>
        <a href="mailto:founders@symphoniclabs.com" className="navbar-contact-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
        </a>
      </div>
    </nav>
  );
}

export default Navbar;
